const breakpoints = {
  sm: "36em",
  md: "48em",
  lg: "62em",
};

export default {
  colors: {
    black: "#0b0e11",
    white: "#fff",
    blue: "#007ce0",
    navy: "#004175",
  },
  space: [0, 4, 8, 16, 32, 64, 128, 256, 512],
  breakpoints,
};
